import React, { useState } from "react";
import { eventButtonType } from "../../../common/types/common";

interface PagingGoToProps {
	currentPage: number;
	onClick: (page: number) => void;
}

export function PagingGoTo({ currentPage, onClick }: PagingGoToProps) {
	const [value, setValue] = useState("");
	const page = value === "" ? currentPage : parseInt(value) - 1;

	const handleChange = (value: string) => {
		const re = /^[0-9\b]+$/;

		if (value === "" || re.test(value)) {
			setValue(value);
		}
	};

	const handleClick = (e: eventButtonType) => {
		e.preventDefault();
		onClick(page);
	};

	return (
		<form className="paging-go-to">
			<label htmlFor="goToPage">Go to page</label>
			<div className="go-to-wrapper">
				<input
					type="text"
					id="goToPage"
					pattern="[0-9]*"
					autoComplete="off"
					placeholder="10"
					value={value}
					onChange={(e) => handleChange(e.target.value)}
				/>
				<button
					type="submit"
					className="btn--goto"
					aria-label="Go"
					onClick={handleClick}
				/>
			</div>
		</form>
	);
}
